import { render, staticRenderFns } from "./DeclineInvitation.vue?vue&type=template&id=08ccd600&scoped=true&"
import script from "./DeclineInvitation.vue?vue&type=script&lang=ts&"
export * from "./DeclineInvitation.vue?vue&type=script&lang=ts&"
import style0 from "./DeclineInvitation.vue?vue&type=style&index=0&id=08ccd600&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ccd600",
  null
  
)

export default component.exports